/** `/no-access` — signed in, but no company's books here are this person's. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "@linkhr/i18n";
import { FullPageNotice } from "../shell/FullPageNotice";

export const Route = createFileRoute("/_auth/no-access")({
  component: NoAccess,
});

function NoAccess(): JSX.Element {
  const { t } = useTranslation("accounting");
  return (
    <FullPageNotice
      heading={t("accounting:app.no_access.title")}
      body={t("accounting:app.no_access.body")}
    />
  );
}
